import React from "react";
import { ContentTemplateModel } from "outbound-api-client/lib/models";
import { Content } from "../../../components";
import { configService } from "../../../services";
import { Helmet } from "react-helmet";

export const ContentTemplate: React.FC<ContentTemplateModel> = ({
  title,
  summary,
  template,
}) => {

  return (
    <>
      <Helmet>
        <title>{configService.current().applicationTitle}</title>
      </Helmet>
      <div className='p-x-1'>
        {title && <h3 className='font-title text-center'>{title}</h3>}
        <p className='font-subtitle'>{summary}</p>
        <Content template={template} />
      </div>
    </>
  )
}